// extracted by mini-css-extract-plugin
export default {"awesomeServices":"awesomeServices_awesomeServices__WVZiC","awesomeServicesContainerCard":"awesomeServices_awesomeServicesContainerCard__OQY4D"};